// ✅ NEW CLEAN & SIMPLE CSPM SLICE — No polling, no per-row state.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CSPMService } from "@/src/services/CSPM/cspmService";

export interface CSPMScanState {
  isScanning: boolean;
  status: "idle" | "scanning" | "completed" | "failed";
  scan_id: string | null;
  scanError: string | null;
  lastScannedProviderId: string | null;

}

const initialState: CSPMScanState = {
  isScanning: false,
  status: "idle",
  scan_id: null,
  scanError: null,
  lastScannedProviderId: null,
};

// ---------------------------------------------------
//  START SCAN
// ---------------------------------------------------
export const startCSPMScan = createAsyncThunk(
  "cspmScan/startScan",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await CSPMService.scanSingleCloudProvider(data);

      // Check if the API response indicates failure
      if (response && response.success === false) {
        return rejectWithValue(response.message || "Scan failed");
      }

      if (response.success) {
        return {
          providerId: data._id,   //  VERY IMPORTANT
          scan_id: response.scan_id,
        };
      }

      return rejectWithValue(response.message);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Scan failed");
    }
  }
);

// ---------------------------------------------------
//  SLICE
// ---------------------------------------------------
const cspmScanSlice = createSlice({
  name: "cspmScan",
  initialState,
  reducers: {
    resetCSPMScanState: () => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(startCSPMScan.pending, (state,action) => {
        state.isScanning = true;
        state.status = "scanning";
        state.scanError = null;
        state.lastScannedProviderId = action.meta.arg._id; 
      })

      .addCase(startCSPMScan.fulfilled, (state, action) => {
        state.isScanning = false;
        state.status = "completed";   //  AUTO SET COMPLETED
        state.scan_id = action.payload.scan_id;
        state.lastScannedProviderId = action.payload.providerId;

      })

      .addCase(startCSPMScan.rejected, (state, action) => {
        state.isScanning = false;
        state.status = "failed";
        state.scanError = action.payload as string || action.error.message || "Scan failed";
      });
  },
});

export const { resetCSPMScanState } = cspmScanSlice.actions;
export default cspmScanSlice.reducer;
